/**
 * Small header used at the top of both /checkout and the modular
 * CheckoutModule. Renders the checkout title and a "Back to basket" link
 * that opens the shared BasketDrawer. The company logo was intentionally
 * removed — the surrounding PageShell already renders the site-wide
 * header/nav so a second logo here was duplicative.
 */
import { ArrowLeft } from "lucide-react";
import { useBasket } from "@/context/BasketContext";

export default function CheckoutHeader({ title = "Checkout" }) {
  const { count, openDrawer } = useBasket();

  return (
    <div className="flex items-center justify-between gap-4 mb-6" data-testid="checkout-header">
      <h1
        className="font-serif"
        style={{ fontSize: "var(--checkout-heading-size, 1.875rem)" }}
        data-testid="checkout-header-title"
      >
        {title}
      </h1>
      <button
        type="button"
        onClick={openDrawer}
        className="text-sm text-muted-foreground hover:text-primary flex items-center gap-1 transition-colors"
        data-testid="checkout-back-to-basket"
        aria-label={count > 0 ? `Back to basket, ${count} item${count === 1 ? "" : "s"}` : "Back to basket"}
      >
        <ArrowLeft className="h-3 w-3" /> Back to basket
        {count > 0 && (
          <span className="ml-1 text-xs bg-muted rounded-full px-1.5" data-testid="checkout-back-count">
            {count}
          </span>
        )}
      </button>
    </div>
  );
}
